
// CONFIG FOR WORDPRESS

thequietlifeConfig.mainBaseURL = 'https://thequietlife.com';
thequietlifeConfig.shopBaseURL = 'https://shop.thequietlife.com';

thequietlifeConfig.isMain = false;
thequietlifeConfig.isShop = true;

if (thequietlifeConfig.isMain) {
  thequietlifeConfig.fullSiteRoot = thequietlifeConfig.mainBaseURL;
} else {
  thequietlifeConfig.fullSiteRoot = thequietlifeConfig.shopBaseURL;
}

thequietlifeConfig.mainBridgeURL = thequietlifeConfig.mainBaseURL + '/bridge/';
thequietlifeConfig.shopBridgeURL = thequietlifeConfig.shopBaseURL + '/pages/bridge/';

// cart

thequietlifeConfig.cartAjaxEnabled = true;
thequietlifeConfig.cartDataBaseURL = thequietlifeConfig.shopBaseURL;

// urls

thequietlifeConfig.collectionURL = thequietlifeConfig.shopBaseURL + '/collections/{collection_slug}';
thequietlifeConfig.collectionProductURL = thequietlifeConfig.shopBaseURL + '/collections/{collection_slug}/products/{product_slug}';
thequietlifeConfig.productURL = thequietlifeConfig.shopBaseURL + '/products/{product_slug}';